<template>
  <!-- TODO: Translate here -->
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="steering-wheel"
    :header_text_short="'AUTO'/*$t('WorkpackageRework.Info.Log.Header')*/"
    :header_text_long="'AUTO.pilots'/*$t('WorkpackageRework.Info.Log.Header').toUpperCase() + '.' + $t('WorkpackageRework.Info.Log.List')*/"
    @headerBack="$router.push({name: `${location}WorkPackageInfo`, params: { nav_back: $route.params.nav_back} })"
  >
    <template #body>
      <!-- TODO: Translate here -->
        <!-- AUTOPILOTS LIST -->
      <CollapsableCategory
        value="AUTO.pilots"
        :color="workpackage_fg_hex"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed">
              <!-- TODO: use actual autopilots instead of this -->
              <div
                v-for="(pilot, index) in autopilotprojects"
                class="work-package-autopilots"
                :key="`pilotitem${index}-${pilot.id}`"
              >
                <ClickableListItem
                  :id="pilot.id"
                  :is_selected="pilot.id === DEBUG_selected_issue /* TODO: check for appropriate id in route, NOTE: $route.params.content_id*/"
                  :is_disabled="false"
                  :has_lines="true"
                  :is_first="index == 0"
                  :is_unclickable="true/*NOTE: for now*/"
                  :background_color="workpackage_bg_hex"
                  :foreground_color="workpackage_fg_hex"
                  @emittedClick="$router.push({
                    name: `${location}WorkPackageAutopilotsDetails`,
                    params: {
                      content_id: $event,
                      nav_back: $route.params.nav_back,
                    }
                  })"
                >
                  <!-- @emittedClick="$emit('clickList', pilot.id)" -->
                  <!-- CLICKABLE LIST SLOTS -->
                  <template #front>
                    <TIcon name="steering-wheel"/>
                  </template>

                  <template #descriptor>
                    <TText
                      :text="getAutopilotName(getUObject({type: 'autopilots', id: pilot.autopilots[0]}))"
                      :color="workpackage_fg_hex"
                      align="left"
                      medium
                    />
                  </template>
                  <!-- <template #info>
                    <TText
                      :text="`${pilot.resolved}/${pilot.count}`"
                      :color="workpackage_fg_hex"
                      align="left"
                      medium
                    />
                  </template> -->
                </ClickableListItem>
              </div>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>

      <!-- TODO: Translate here -->
      <!-- ISSUE LIST -->
      <CollapsableCategory
        value="Issues"
        :color="workpackage_fg_hex"
        :init_expanded="true"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed">
              <div
                v-for="(issue, index) in issues"
                class="work-package-autopilots"
                :key="`issueitem${index}-${issue.id}`"
              >
                <ClickableListItem
                  :id="issue.id"
                  :is_selected="issue.id === DEBUG_selected_issue /* TODO: check for appropriate id in route, NOTE: $route.params.content_id*/"
                  :is_disabled="false"
                  :has_lines="true"
                  :is_first="index == 0"
                  :background_color="workpackage_bg_hex"
                  :foreground_color="workpackage_fg_hex"
                  @emittedClick="$router.push({
                    name: `${location}WorkPackageAutopilotsDetails`,
                    params: {
                      content_id: $event,
                      nav_back: $route.params.nav_back,
                    }
                  })"
                >
                  <!-- @emittedClick="$emit('clickList', issue.id)" -->
                  <!-- CLICKABLE LIST SLOTS -->
                  <template #front>
                    <TIcon :name="getIssuesIcon(issue)"/>
                  </template>

                  <template #descriptor>
                    <TText
                      :text="`${/*issue.autopilot.function*/getAutopilotName(issue.autopilot)}: Issue #${issue.uuid}`"
                      :color="workpackage_fg_hex"
                      align="left"
                      medium
                    />
                  </template>
                </ClickableListItem>
              </div>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    </template>

  </WorkPackageSubPageModule>
</template>

<script>
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js';
import { mapGetters, mapActions } from 'vuex';

  export default {
    components: {
      WorkPackageSubPageModule,
      ClickableListItem,
      CollapsableCategory,
      TText,
      TIcon,
      TransitionAccordion,
    },

    props: [
      'location',
    ],

    mixins: [
      WorkPackageReworkMixin,
    ],

    data: () => ({
      show_filter: false,
      DEBUG_selected_issue: -1,
      DEBUG_selected_autopilot: -1,
    }),

    computed: {
      issues(){
        return this.getUObjects({ type: 'autopilotissues', ids: this.workpackage.autopilotissues});
      },
      autopilotprojects(){
        return this.getUObjects({ type: 'autopilotprojects', ids: this.workpackage.autopilotprojects});
      },
      ...mapGetters('Autopilot', [
        'getAutopilotName'
      ]),
      ...mapGetters('Ultra', [
        'getUObject',
        'getUObjects',
      ]),
    },

    created() {
      this.loadData();
    },

    watch: {
      tworkpackage_id() {
        this.loadData();
      },
    },

    methods: {
      ...mapActions('Ultra', [
        'requestUObject'
      ]),

      getIssuesIcon(issue) {
        switch (issue.status) {
          case 'resolved':
            return 'lock-closed';
          case 'overruled':
            return 'lock-closed-warning';
          case 'open':
            return 'lock-open';
          default:
            return 'lock-closed-warning';
        }
      },

      test() {
        console.log("test ok");
      },

      loadData() {
        this.requestUObject({
          url: [
            { projects: this.$route.params.project_id },
            { trains: this.$route.params.train_id },
            { taktareas: this.$route.params.taktarea_id },
            { twaggons: this.$route.params.twaggon_id },
            { tworkpackages: this.$route.params.tworkpackage_id },
            { autopilotprojects: '' },
            { showWithEntitiesNormalized: '' }
          ],
          add_u_object: true
        });
        this.requestUObject({
          url: [
            { projects: this.$route.params.project_id },
            { trains: this.$route.params.train_id },
            { taktareas: this.$route.params.taktarea_id },
            { twaggons: this.$route.params.twaggon_id },
            { tworkpackages: this.$route.params.tworkpackage_id },
            { autopilotissues: '' },
            { showWithEntitiesNormalized: '' }
          ],
          add_u_object: true
        });
      },
    },
  }
</script>

<style>
  .work-package-autopilots {
    width: 100%;
  }
</style>
